import { Bell } from "lucide-react";

import {
  useNotificationsStore,
} from "@/features/notifications/model/notificationsStore";
import { useUnreadCount } from "@/features/notifications/model/useNotifications";
import { NotificationDrawer } from "@/features/notifications/ui/NotificationDrawer";
import { cn } from "@/shared/lib/cn";

export function NotificationBell() {
  const toggleDrawer = useNotificationsStore((s) => s.toggleDrawer);
  const drawerOpen = useNotificationsStore((s) => s.drawerOpen);
  const { data: unreadCount = 0 } = useUnreadCount();

  // Cap the badge for sanity; show "9+" when over.
  const badgeLabel = unreadCount > 9 ? "9+" : String(unreadCount);
  const hasUnread = unreadCount > 0;

  return (
    <div className="relative">
      <button
        type="button"
        aria-label={
          hasUnread
            ? `Notifications (${unreadCount} unread)`
            : "Notifications"
        }
        aria-expanded={drawerOpen}
        onClick={toggleDrawer}
        className={cn(
          "relative inline-flex h-9 w-9 items-center justify-center rounded-md text-copy-muted transition-colors",
          "hover:bg-surface-sunken hover:text-copy",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        )}
      >
        <Bell className="h-4 w-4" />
        {hasUnread && (
          <span
            className={cn(
              "absolute -top-0.5 -right-0.5 inline-flex min-w-[18px] items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-semibold leading-none text-primary-foreground",
              "h-[18px] tabular-nums",
            )}
          >
            {badgeLabel}
          </span>
        )}
      </button>

      <NotificationDrawer />
    </div>
  );
}
